export const billingEventsFiscalDocumentsDefaultColumns = [
  { label: '', value: 'id', hidden: true },
  { label: 'Status', value: 'status' },
  { label: 'Transação', value: 'protocol_number' },
  { label: 'Tipo', value: 'type' },
  { label: 'Detalhes', value: 'details' },
  { label: 'Valor total', value: 'total_amount' },
  { label: 'Data e hora', value: 'created_at' },
  { label: 'Ações', value: 'action', className: 'w-9' },
];
